export default {
      id: "sli-settings-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#sli-settings",
      toString: function () {
        return this.url;
      }
    }